module.exports = __webpack_public_path__ + "assets/img/2.efbe705f.png";